import { useState } from 'react'
import AccordionServicos from './accordionServicos'
import CardServicos from './cardServicos'
import OtimizeSeuNegocio from './OtimizeSeuNegocio'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './carousel'
import Container from './container'

export default function SolucoesDesenvolvimento() {
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const [expandedMobileIndex, setExpandedMobileIndex] = useState(null)
  
  // Handle accordion toggle in mobile view - similar to etapas.jsx
  const handleAccordionToggle = (index, isOpen) => {
    if (isOpen) {
      // Close any previously opened accordion
      if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
        // Find the previously opened accordion and close it
        const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
        if (prevAccordion) {
          prevAccordion.click();
        }
      }
      setExpandedMobileIndex(index);
    } else if (expandedMobileIndex === index) {
      setExpandedMobileIndex(null);
    }
  }
  const servicosData = [
    {
      id: 1,
      icon: '../assets/servicos/aplicativos_icon.svg',
      iconHover: '../assets/servicos/aplicativos_icon.svg',
      title: 'APLICATIVOS MÓVEIS',
      text: 'Nossas soluções de desenvolvimento de aplicativos se adaptam às suas necessidades: utilizamos tecnologias nativas ou híbridas, e aplicamos métodos ágeis para testar seu modelo de negócio rapidamente. À medida que suas demandas evoluem, aprimoramos a arquitetura das soluções para ampliar a  robustez.',
      glowColor: '#A800E4',
      url: '',
    },
    {
      id: 2,
      icon: '../assets/servicos/plataformas_icon.svg',
      iconHover: '../assets/servicos/plataformas_icon.svg',
      title: 'PLATAFORMAS, SAAS, APIS',
      text: 'Desenvolvemos plataformas escaláveis e de alto desempenho, otimizadas para serviços em nuvem, assegurando que sua infraestrutura atenda a demandas elevadas e suporte o crescimento futuro.',
      glowColor: '#A800E4',
      url: '',
    },
    {
      id: 3,
      icon: '../assets/servicos/softwares_icon.svg',
      iconHover: '../assets/servicos/softwares_icon.svg',
      title: 'SOFTWARES SOB MEDIDA',
      text: 'Soluções personalizadas para automatizar processos, transformando serviços manuais em digitais, aprimorando a gestão, aumentando as vendas e integrando softwares de terceiros de forma eficiente.',
      glowColor: '#A800E4',
      url: '',
    },
    {
      id: 4,
      icon: '../assets/servicos/rpa_icon.svg',
      iconHover: '../assets/servicos/rpa_icon.svg',
      title: 'RPA',
      text: 'Soluções sob medida para automatizar processos, transformar serviços manuais em digitais, aprimorar a gestão, aumentar as vendas e integrar softwares de terceiros de forma eficiente.',
      glowColor: '#A800E4',
      url: '',
    },
  ]

  return (
    <section className="bg-[#0F083A] md:min-h-screen py-16 text-white overflow-hidden relative">
      <Container className="lg:max-w-[1240px] space-y-9 relative z-10">
        <header className="grid grid-cols-1 xl:grid-cols-2 items-center gap-6 md:gap-0">
          <div className="space-y-12">
            <h2 className="text-3xl text-center md:text-left lg:text-6xl font-inter-regular pl-0 md:pl-16">
              Soluções em{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#A800E4] via-[#D700E2] via-[#FB00C7] via-[#FF00A0] to-[#FF1B76]">
                desenvolvimento
              </span>
            </h2>
          </div>
          <div>
            <p className="font-inter-regular text-xs text-center md:text-left md:text-2xl">
              Desenvolvemos as melhores soluções, a partir do entendimento das
              necessidades do seu negócio.
            </p>
          </div>
        </header>
        {/* Removed the static Otimize component - it will now appear on hover */}
        <main className="overflow-visible">
          <Carousel className="w-full hidden md:block">
            <CarouselContent className="py-12 gap-2 mt-8 px-8 pr-4">
              {servicosData.map((servico, index) => (
                <CarouselItem
                  key={index}
                  className="basis-full sm:basis-1/2 md:basis-1/3"
                >
                  <div 
                    className="relative"
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    {/* Otimize component that appears on hover at the top of the card */}
                    <div 
                      className={`absolute top-[-110px] left-0 right-0 z-20 transition-all duration-300 ${hoveredIndex === index ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
                    >
                      <OtimizeSeuNegocio 
                        text="Otimize seu negócio!"
                        buttonText="Contratar"
                        useFormularioRD={true}
                        type="gradient"
                        className="w-full"
                      />
                    </div>
                    
                    <CardServicos {...servico} height={400} />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-end absolute right-16 bottom-8 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
          </Carousel>

          <div className="md:hidden space-y-3">
            {servicosData.map((card, index) => (
              <div key={index} className="relative">
                <AccordionServicos
                  key={`mobile-${index}`}
                  {...card}
                  className="bg-[rgb(36,29,73)] backdrop-blur-[92px]"
                  doesThereButton={false}
                  onToggle={(isOpen) => handleAccordionToggle(index, isOpen)}
                  accordionIndex={index}
                />
                
                {/* Mobile OtimizeSeuNegocio that appears when accordion is expanded */}
                <div 
                  className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                    ${expandedMobileIndex === index ? 'max-h-[100px] opacity-100' : 'max-h-0 opacity-0'}`}
                  style={{
                    transitionProperty: 'max-height, opacity, transform',
                    transform: expandedMobileIndex === index ? 'translateY(0)' : 'translateY(-10px)',
                    zIndex: 20,
                    position: 'relative'
                  }}
                >
                  <div className="mt-4">
                    <OtimizeSeuNegocio 
                      text="Otimize seu negócio!"
                      buttonText="Contratar"
                      useFormularioRD={true}
                      type="gradient"
                      className="w-full"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </main>
      </Container>
      <img
        src="../assets/gradiente.png"
        alt=""
        className="hidden md:block w-full absolute left-0 bottom-0 object-cover z-0 h-fit"
      />
    </section>
  )
}
